import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ForsyningIndstillingerRepository } from "@e-forsyning/common/forsyning-indstillinger";

@Injectable({ providedIn: "root" })
export class FeatureFlagService {
    private readonly pilotKundeToggle$: BehaviorSubject<boolean>;

    constructor(private readonly forsyningIndstillingerRepository: ForsyningIndstillingerRepository) {
        this.pilotKundeToggle$ = new BehaviorSubject<boolean>(false);
    }

    isFeatureEnabled(): boolean {
        return this.pilotKundeToggle$.getValue();
    }

    isFeatureEnabledObservable(): Observable<boolean> {
        return this.pilotKundeToggle$.asObservable();
    }

    setPilotKundeToggle(enabled: boolean): void {
        this.pilotKundeToggle$.next(enabled);
    }

    initialize(forsyningId: string): void {
        if (!forsyningId) {
            this.setPilotKundeToggle(false);
            return;
        }

        this.forsyningIndstillingerRepository.hentForsyningIndstillinger(forsyningId).subscribe({
            next: (settings) => this.setPilotKundeToggle(!!(settings && settings.pilotKundeToggle)),
            error: () => this.setPilotKundeToggle(false)
        });
    }
}
